import React from "react";

interface QuantitySelectorProps {
  quantity: number;
  setQuantity: (quantity: number) => void;
  maxQuantity?: number;
}

const QuantitySelector = ({ quantity, setQuantity, maxQuantity }: QuantitySelectorProps) => {
  return (
    <div className="flex w-full justify-between items-center bg-white md:bg-grey-fields-200 rounded-10 py-3 px-0 md:px-3">
      <dt className="text-1xs sm:text-sm text-black">Quantity</dt>
      <dd className="no-outline inline-flex items-center rounded-full flex-shrink-0">
        <div className="flex items-center space-x-1">
          <button
            className="flex-shrink-0 h-7 w-7 sm:h-8 sm:w-8 rounded-full bg-grey-fields-100 border border-grey-border border-opacity-50 inline-flex items-center justify-center text-placeholder shadow-primary disabled:cursor-not-allowed"
            disabled={quantity < 2}
            onClick={() => setQuantity(quantity - 1)}
          >
            {/* prettier-ignore */}
            <svg className="w-[60%]" viewBox="0 0 18 18" fill="none">
              <path d="M4.5 9H13.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </button>

          <div className="flex items-stretch">
            <input
              type="number"
              className="w-8 block h-8 sm:w-9 sm:h-9 rounded-5 border-grey-divider focus:border-primary-500 border no-outline text-center font-semibold text-xxxs sm:text-xs text-dark"
              value={quantity}
              onChange={(e) => setQuantity(Number(e.target.value))}
              min={1}
              max={maxQuantity}
            />
          </div>
          <button
            onClick={() => setQuantity(quantity + 1)}
            className="flex-shrink-0 h-7 w-7 sm:h-8 sm:w-8 rounded-full bg-grey-fields-100 border border-grey-border border-opacity-50 inline-flex items-center justify-center text-placeholder shadow-primary"
          >
            {/* prettier-ignore */}
            <svg className="w-[60%]" viewBox="0 0 18 18" fill="none">
              <path d="M4.5 9H13.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
              <path d="M9 13.5V4.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </button>
        </div>
      </dd>
    </div>
  );
};

export default QuantitySelector;
